import React from "react";
import { Redirect, Route } from "react-router-dom";

const PrivateRoutePagoEfectivo = ({ children, ...props }) => {
  try {
    const usuario = JSON.parse(localStorage.getItem("usuario"));

    const isAuthenticated =
      usuario?.nombre &&
      usuario?.token &&
      usuario?.rol &&
      usuario?.id_municipio &&
      usuario?.id_oficina;

    const hasAccess =
      usuario?.rol === "Administrador" || usuario?.rol === "Ventanilla";

    if (isAuthenticated && hasAccess) {
      return <Route {...props}>{children}</Route>;
    } else {
      return <Redirect to="/" />;
    }
  } catch (error) {
    return <Redirect to="/login" />;
  }
};

export default PrivateRoutePagoEfectivo;
